export const DatePickerDateFormats = ['MM/DD/YYYY', 'M/D/YYYY', 'MM/DD/YY', 
  'YYYY/MM/DD', 'MM-DD-YYYY', 'M-D-YYYY', 'MM-DD-YY', 
  'YYYY-MM-DD', 'MMDDYYYY', 'MMDDYY', 'M/D/YY'];